import type { FlowVariant, WelcomeVariant } from "./types";

const FLOW_ALIASES: Record<string, FlowVariant> = {
  a: "a",
  b: "b",
  daily_routine: "a",
  old_testament: "a",
  ot: "a",
  flow_a: "a",
  flowa: "a",
  new_testament: "b",
  nt: "b",
  flow_b: "b",
  flowb: "b"
};

const normalize = (value: string): string => {
  return value.toLowerCase().replace(/[^a-z0-9]/g, "_");
};

const fromAlias = (value: string | null): string | null => {
  if (!value) {
    return null;
  }

  const alias = normalize(value);
  return Object.prototype.hasOwnProperty.call(FLOW_ALIASES, alias) ? alias : null;
};

export const resolveFlowFromUrl = (
  urlLike: URL | string = window.location.href
): FlowVariant => {
  return resolveFlowFromUrlOrNull(urlLike) ?? "a";
};

export const resolveFlowFromUrlOrNull = (
  urlLike: URL | string = window.location.href
): FlowVariant | null => {
  const alias = resolveEntryAlias(urlLike);
  return alias ? FLOW_ALIASES[alias] : null;
};

// The Daily Routine entry uses flow A's quiz; only its welcome title differs.
export const resolveWelcomeVariantFromUrl = (
  urlLike: URL | string = window.location.href
): WelcomeVariant => resolveEntryAlias(urlLike) === "daily_routine" ? "daily_routine" : "default";

const resolveEntryAlias = (urlLike: URL | string): string | null => {
  const url = typeof urlLike === "string" ? new URL(urlLike) : urlLike;

  // Query wins over path, in flow / variant / type order.
  const queryFlow =
    fromAlias(url.searchParams.get("flow")) ??
    fromAlias(url.searchParams.get("variant")) ??
    fromAlias(url.searchParams.get("type"));
  if (queryFlow) {
    return queryFlow;
  }

  // Then try path segments, starting at the end.
  const pathSegments = url.pathname.split("/").filter(Boolean);
  for (let index = pathSegments.length - 1; index >= 0; index -= 1) {
    const matched = fromAlias(pathSegments[index]);
    if (matched) {
      return matched;
    }
  }

  return null;
};
